module.exports = __webpack_public_path__ + "res/dummy_ads.07f534d1501e4a33de00bc52b2ad1e71.png";